import { Alert, Box, Button } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';
import { AuthLayout } from '@shared/layouts';
import PageContainer from '@shared/components/container/PageContainer';
import { InitialPageLoader } from '@shared/components/InitialPageLoader';
import { useSsoCallback } from '@features/Auth/Sso';

export const SsoPage = () => {
  const { errorMsg, backToSignIn } = useSsoCallback();

  return (
    <PageContainer title="Signing in" useProductSuffix>
      <AuthLayout>
        {errorMsg ? (
          <Box
            sx={{
              width: '418px',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              padding: '30px',
              borderRadius: '12px',
              backgroundColor: '#FFFFFF',
              border: '1px solid #DFE5EF',
              boxShadow: '0px 10px 10px rgba(42, 53, 71, 0.1)',
            }}>
            <Alert severity="error" icon={<ErrorOutline />} role="alert" aria-live="polite">
              {errorMsg}
            </Alert>
            <Button fullWidth variant="contained" onClick={backToSignIn}>
              Back to sign in
            </Button>
          </Box>
        ) : (
          <InitialPageLoader message="Signing you in..." />
        )}
      </AuthLayout>
    </PageContainer>
  );
};
